export const APP_HEADER_HEIGHT = 63;
export const SIDEBAR_OPEN_WIDTH = 320;
export const SIDEBAR_CLOSED_WIDTH = 20;
